import { useContent } from '@altify/utils';
import { ReactNode } from 'react';
import { Text, View } from 'react-native';
import { Heading } from '../../Core/Heading/Heading';
import { Typography } from '../../Core/Typography/Typography';
import { InfoIcon } from '../../Icons/InfoIcon';
import { cn } from '../../lib/utils';
import { content } from './Calendar.content';
import { CircularButton } from './components/CircularButton';

interface MonthCalendarProps {
  daySelection?: number;
  className?: string;
  circularButtonClassName?: string;
  onChange?: (value: number) => void;
}

export const MonthCalendar = ({
  daySelection = 1,
  className,
  circularButtonClassName,
  onChange,
}: MonthCalendarProps) => {
  const localizedContent = useContent(content);
  const monthDays = Array.from({ length: 28 }, (_, i) => i + 1);

  const rows = monthDays.reduce((acc: ReactNode[], _, index) => {
    if (index % 7 === 0) {
      const rowItems = monthDays.slice(index, index + 7);
      acc.push(
        <View
          key={`row-${index}`}
          className="flex-row justify-evenly mb-2 px-1">
          {rowItems.map((item, subIndex) => (
            <CircularButton
              className={circularButtonClassName}
              key={`${item}${subIndex}`}
              onPress={() => {
                onChange?.(item);
              }}
              isSelected={daySelection === item}
              text={item.toString()}
            />
          ))}
        </View>,
      );
    }
    return acc;
  }, []);

  return (
    <View
      className={cn(
        'bg-neutral-600 rounded-[10px] flex border border-neutral-500 p-3',
        className,
      )}>
      <Text className="mt-4 text-center mb-8">
        <Heading level={4}>{localizedContent.buyMonthDate.buyOn + ' '}</Heading>
        <Heading level={4} className="text-primary">
          {localizedContent.date(daySelection) + ' '}
        </Heading>
        <Heading level={4}>{localizedContent.buyMonthDate.eachMonth}</Heading>
      </Text>
      {rows}
      <View className="flex-row items-center mt-6 mb-4 justify-center">
        <InfoIcon className="mr-1 fill-[#F8F9FBCC]" />
        <Typography
          size="small"
          variant="callToAction"
          className="text-[#F8F9FBCC] opacity-80">
          {localizedContent.unavailableDates}
        </Typography>
      </View>
    </View>
  );
};
